import { Typography } from "@material-tailwind/react";
import TechnicianTimeTypesAdminActions from "../../../views/super-admin/views/settings/tabs/technician-time-types/TechnicianTimeTypesAdminActions";

/**
* TechnicianTimeTypeListItem: Display technician time type list item
* @param type - Time type data
* @param onClick - On click event
* @param isLast - Is last item
*/
export default function TechnicianTimeTypeListItem({
  type,
  onClick,
  onChange,
  isLast = false
}: {
  type: EasyTech.TimeType,
  onClick?: () => void,
  onChange: () => void,
  isLast?: boolean
}) {
  return (
    <tr className={`page-list-item ${isLast && "last"}`} onClick={() => onClick && onClick()}>
      <td>
        <div className="flex gap-2 items-center">
          <Typography>{type.label}</Typography>
        </div>
      </td>

      <td>
        <div className="flex gap-2 items-center">
          <Typography>{type.visibility === "ALL" ? "All users" : "Administrators only"}</Typography>
        </div>
      </td>
      <td><TechnicianTimeTypesAdminActions type={type} onChange={onChange} /></td>
    </tr>
  );
}
